import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertsHandlerComponent } from 'src/app/shared/components/alerts-handler/alerts-handler.component';
import { FooterComponent } from 'src/app/shared/components/footer/footer.component';
import { HeaderComponent } from 'src/app/shared/components/header/header.component';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
  imports: [HeaderComponent, RouterOutlet, AlertsHandlerComponent, FooterComponent]

})
export class LayoutComponent {

  constructor() { }

}
